"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MAX_MOBILE_SCREEN_WIDTH = exports.MARGIN_SIDE = exports.LINE_HEIGHT = exports.TIMELINE_HEIGHT = void 0;
require("./styles.css");
var react_1 = __importStar(require("react"));
var Timeline_1 = __importDefault(require("./timeline/Timeline"));
var EventDetails_1 = __importDefault(require("./pieces/EventDetails"));
var Summary_1 = __importDefault(require("./pieces/Summary"));
var TimelineTitle_1 = __importDefault(require("./pieces/TimelineTitle"));
var PersonalInfo_1 = __importDefault(require("./pieces/PersonalInfo"));
var TechnicalInfo_1 = __importDefault(require("./pieces/TechnicalInfo"));
var PictureOfMe_1 = __importDefault(require("./pieces/PictureOfMe"));
var SeeSource_1 = __importDefault(require("./pieces/SeeSource"));
var SwitchLanguage_1 = __importDefault(require("./pieces/SwitchLanguage"));
var react_i18next_1 = require("react-i18next");
exports.TIMELINE_HEIGHT = 250;
exports.LINE_HEIGHT = 60;
exports.MARGIN_SIDE = 5;
exports.MAX_MOBILE_SCREEN_WIDTH = 700;
function getScreenWidth() {
    return Math.min(document.documentElement.clientWidth, window.innerWidth);
}
var App = function () {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var changeLanguage = function (lng) {
        i18n.changeLanguage(lng);
        window.location.hash = "";
    };
    var _b = react_1["default"].useState(null), selectedEvent = _b[0], setSelectedEvent = _b[1];
    var _c = react_1["default"].useState(0), eventDetailsX = _c[0], setEventDetailsX = _c[1];
    var _d = react_1["default"].useState(0), eventDetailsY = _d[0], setEventDetailsY = _d[1];
    var _e = react_1["default"].useState(window.scrollY), scrollY = _e[0], setScrollY = _e[1];
    var _f = react_1["default"].useState(getScreenWidth()), screenWidth = _f[0], setScreenWidth = _f[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setScreenWidth(getScreenWidth());
        };
        window.addEventListener("resize", handleResize);
        var handleScroll = function () {
            setScrollY(window.scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return function () {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var handleEventSelected = function (event, mouseX, mouseY) {
        setSelectedEvent(event);
        setEventDetailsX(mouseX);
        setEventDetailsY(mouseY);
    };
    var handleEventDeselected = function () {
        setSelectedEvent(null);
    };
    return (react_1["default"].createElement(react_i18next_1.I18nextProvider, { i18n: i18n },
        react_1["default"].createElement("div", { className: "App" },
            react_1["default"].createElement("h1", null, "Timmy O'Toole"),
            react_1["default"].createElement("h6", null, t('introText')),
            react_1["default"].createElement(SwitchLanguage_1["default"], { onLanguageSwitch: changeLanguage }),
            react_1["default"].createElement(SeeSource_1["default"], null),
            react_1["default"].createElement(Summary_1["default"], null),
            react_1["default"].createElement(TimelineTitle_1["default"], null),
            react_1["default"].createElement(Timeline_1["default"], { onEventSelected: handleEventSelected, onEventDeselected: handleEventDeselected, selectedEvent: selectedEvent, screenWidth: screenWidth, scrollY: scrollY }),
            react_1["default"].createElement("div", { className: "infoSection" },
                react_1["default"].createElement(TechnicalInfo_1["default"], null),
                react_1["default"].createElement(PersonalInfo_1["default"], null),
                react_1["default"].createElement(PictureOfMe_1["default"], null)),
            selectedEvent && (react_1["default"].createElement(EventDetails_1["default"], { x: eventDetailsX, y: eventDetailsY, event: selectedEvent, onClose: handleEventDeselected, scrollY: scrollY })),
            react_1["default"].createElement("div", { style: { position: "absolute", left: "-9999px", opacity: 0 }, autoFocus: true, tabIndex: -1 }))));
};
exports["default"] = App;
